import doubleChanceLottoService from "../services/doubleChanceLotto.service";

const handlers = {
    doubleChanceLotto: {
        session: {
            set: "doublechancelotto_session_set"
        }
    }
}

const initVuexState = function(state) {
    state.doubleChanceLotto = {
        session: null
    };
}

const initGetters = function(getters) {
    getters.doubleChanceLotto = (state => state.doubleChanceLotto);
}

const initActions = function(actions) {
    actions[handlers.doubleChanceLotto.session.set] = ({ commit }, session) => commit(handlers.doubleChanceLotto.session.set, session);
}

const initMutations = function(mutations) {
    mutations[handlers.doubleChanceLotto.session.set] = (state, session) => state.doubleChanceLotto.session = session;
}

const initAppState = function(appState, store) {
    appState.doubleChanceLotto = {
        session: {
            get: () => store.getters.doubleChanceLotto.session,
            open: async options => {
                const session = await doubleChanceLottoService.openSession(options);
                store.dispatch(handlers.doubleChanceLotto.session.set, session);
            },
            close: async () => {
                store.getters.doubleChanceLotto.session && await doubleChanceLottoService.closeSession();
                store.dispatch(handlers.doubleChanceLotto.session.set, null);
            }
        }
    }
}

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};


// WEBPACK FOOTER //
// ./_common/data/doubleChanceLotto.js